export const types = {
	success: 'ALERT_SUCCESS',
	warning: 'ALERT_WARNING',
	danger: 'ALERT_DANGER',
	remove: 'ALERT_REMOVE',
	info: 'ALERT_INFO',
};
